import React, { useState, useEffect } from 'react';
import './App.scss';
import './Loader.css';
import TimeService from './services/TimeService';

function App() {
  const [times, setTimes] = useState([]);
  const [timeLoaded, setTimeLoaded] = useState(false);

  useEffect(() => {
    getTimes();
  }, []);

  async function getTimes() {
    setTimeLoaded(false);
    const response = await TimeService.getTimes();
    const { wakts } = response.data;
    setTimes(wakts);
    setTimeLoaded(true);
  }

  return (
    <div>
      {!timeLoaded && (
        <div className='overlay'>
          <div className='lds-heart'>
            <div></div>
          </div>
        </div>
      )}
      <div className='container'>
        <h1 className='title'>Moscow Namaz Times</h1>
        <div className='refresh-btn'>
          <button onClick={() => getTimes()}>Refresh</button>
        </div>
        {timeLoaded && (
          <div className='times'>
            {times.map((t) => (
              <div
                className={
                  's-time ' +
                  (t.active ? 'active ' : '') +
                  (t.timeOver ? 'time-over' : '')
                }
                key={t.name}
              >
                <p className='name'>{t.name}</p>
                <p className='time'>{t.time}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
